module.exports = __webpack_public_path__ + "ac38b1fc0b68310be48d70b51e45ff31.fbx";